import type { JSX } from 'react';

import { Charges } from '../components/Charges.tsx';
import { RecentGames } from '../components/RecentGames.tsx';
import { WorkHistory } from '../components/WorkHistory.tsx';

/** What happened: every charge, every game recorded and every minute worked. */
export function History(): JSX.Element {
  return (
    <>
      <Charges title="Charges" />
      <WorkHistory />
      <RecentGames />
    </>
  );
}
